

import React from 'react';

const DotSvg = () => {
  return (
    <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.51193 10C4.29929 10 3.30713 10.9 3.30713 12C3.30713 13.1 4.29929 14 5.51193 14C6.72456 14 7.71672 13.1 7.71672 12C7.71672 10.9 6.72456 10 5.51193 10Z"
        stroke="#A9ABAD"
        strokeWidth="1.5"
      />
      <path
        d="M20.9455 10C19.7329 10 18.7407 10.9 18.7407 12C18.7407 13.1 19.7329 14 20.9455 14C22.1582 14 23.1503 13.1 23.1503 12C23.1503 10.9 22.1582 10 20.9455 10Z"
        stroke="#A9ABAD"
        strokeWidth="1.5"
      />
      <path
        d="M13.2287 10C12.0161 10 11.0239 10.9 11.0239 12C11.0239 13.1 12.0161 14 13.2287 14C14.4414 14 15.4335 13.1 15.4335 12C15.4335 10.9 14.4414 10 13.2287 10Z"
        stroke="#A9ABAD"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default DotSvg;

